import enTranslations from './en.json';
import deTranslations from './de.json';

const translations = {
  en: enTranslations,
  de: deTranslations
};
export default translations;


